import React from "react";

const VisitBox = (props) => {

  const boxStyle = {
    background: "linear-gradient(135deg,rgb(116, 74, 160) 0%,rgb(85, 133, 216) 100%)",
    color: "white",
    padding: "10px",
    borderRadius: "15px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    textAlign: "center",
    width: "100%",
    height: "50px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "10px",
    marginTop: "10px",
  };

  const headingStyle = {
    fontSize: "1.1rem",
    fontWeight: "600",
    marginBottom: "5px",
  };

  const paragraphStyle = {
    fontSize: "1.5rem",
    fontWeight: "700",
    marginLeft: "10px",
    marginTop: "10px",
  };

  return (
    <div style={boxStyle}>
      <h2 style={headingStyle}>Commutes Served:</h2>
      <p style={paragraphStyle}>{props.totalVisits} 😊</p>
    </div>
  );
};

export default VisitBox;